import type { ThemeConfig } from 'antd';

export const antTheme: ThemeConfig = {
  token: {
    // Primary colors
    colorPrimary: '#0066ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',

    // Font
    fontFamily:
      "'Inter', 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,

    // Border radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,

    // Layout
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,

    // Spacing
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,

    // Shadows
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    boxShadowSecondary: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
  components: {
    Button: {
      primaryShadow: '0 2px 0 rgba(0, 102, 255, 0.1)',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'transparent',
      darkItemSelectedBg: '#3d4e60',
    },
    Table: {
      headerBg: '#fafafa',
      headerColor: '#4D4D4D',
    },
    Card: {
      paddingLG: 24,
    },
    Form: {
      verticalLabelPadding: '0 0 8px',
      labelColor: '#333333',
    },
    Input: {
      controlHeight: 44,
    },
    Select: {
      controlHeight: 44,
    },
    DatePicker: {
      controlHeight: 44,
    },
  },
};

export default antTheme;

